import React from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Typography,
  Chip,
} from "@mui/material";
import { format } from "date-fns";

export default function InvitedClientsTable({ clients }) {
  console.log("InvitedClientsTable clients:", clients);

  return (
    <Paper sx={{ p: 3, borderRadius: 2, overflowX: "auto" }}>
      <Typography variant="h6" fontWeight={600} sx={{ mb: 2 }}>
        Invited Clients
      </Typography>
      {clients.length === 0 ? (
        <Typography color="text.secondary">No invites yet.</Typography>
      ) : (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Email</TableCell>
              <TableCell>Invited At</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {clients
              .filter((c) => !c.clientUid)
              .map((c) => (
                <TableRow key={c.id}>
                  <TableCell>{c.clientEmail}</TableCell>
                  <TableCell>
                    {c.invitedAt?.toDate
                      ? format(c.invitedAt.toDate(), "dd MMM yyyy")
                      : "—"}
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={c.clientUid ? "Accepted" : "Pending"}
                      color={c.clientUid ? "success" : "warning"}
                      size="small"
                      variant="outlined"
                    />
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      )}
    </Paper>
  );
}
